import { Partner } from '@/services/api/contracts/partners';
import { MappedCustomerCreditCheck, useMspCreditChecks } from '@/services/api/hooks/credit';
import { usePartners } from '@/services/api/hooks/partners';

export const useBuildMspCreditChecks = () => {
  const [creditChecks] = useMspCreditChecks();

  const [msps] = usePartners();

  return msps.map((msp: Partner) => {
    const creditCheckLookup = creditChecks.items.find(item => item.mspId === msp.id);

    return {
      id: msp.id,
      creditLimitId: creditCheckLookup?.id,
      name: msp.name,
      number: msp.registeredInfo.number,
      creditLimit: creditCheckLookup?.creditLimit,
      createdAt: creditCheckLookup?.effectiveDate.createdOn
        ? new Date(creditCheckLookup?.effectiveDate.createdOn)
        : undefined,
      lastModified: creditCheckLookup?.effectiveDate.value
        ? new Date(creditCheckLookup?.effectiveDate.value)
        : undefined,
      userId: creditCheckLookup?.effectiveDate.userId,
      regionCode: msp.region.code
    } as MappedCustomerCreditCheck;
  });
};
